import URLValue from './URLValue';

interface VILTSettignsProps {
    lti_creds_uuid: string;
}

const VILTSettings: React.FC<VILTSettignsProps> = ({ lti_creds_uuid }) => {
    const url = `/v1/vilt-connector/${lti_creds_uuid}`;

    return <URLValue path={url} />;
};
export default VILTSettings;
